/**
 * 基础配置
 */
import i18n from '@/utils/i18n'
import { getFetchList, getVisitorAuditState, webTracking } from '@/api/index'
import { getToken } from '@/utils/auth'
import { getType } from '@/utils/function'
import router from '@/router'
import store from '@/store'
import config from '@/config/index'

/**
 * 进入登录页面时 记录来源页面的地址 方便登录成功后 跳回来源页面
 * params (Object|String)
 *  Object => {
 *    path: String
 *    source: Boolean
 *    replaceStatus: Boolean
 *  }
 */
export const loginSource = (params='/') => {
  if (!['string', 'object'].includes(getType(params))) return
  if (params == '') return
  let path
  let source = false
  let replaceStatus = false
  let pathLocation = ''
  let query
  if (getType(params) == 'object') {
    if (!params.path) {
      params.path = '/'
    }
    path = params.path
    source = !!params.source
    replaceStatus = !!params.replaceStatus
    query = params.query || {}
  } else {
    path = params
  }
  pathLocation = path.split('?')
  if (['/', '/login', '/login/actor', '/login/person'].includes(pathLocation)) return
  if (source) {
    window.sessionStorage.setItem('toPath', window.location.pathname)
  }
  console.log('qqqqqq')
  if (replaceStatus) {
    router.replace(path)
  } else {
    router.push({ path, query })
  }
}

/**
 * 登录成功后的跳转
 * @param {string}  subjectType 登录者身份 观众，展商
 * @param {boolean} type  true => 邮箱 false => 手机号
 * @param {object}  value question(是否注册流程的问卷页面)/email/phone/secondInfo(是否跳转预登记【完善信息2 + 问卷】)/firstInfo(是否来自完善信息1)
 */
const loginSuccess = function(subjectType, param = {}, type, value) {
  let info = store.getters.info
  let goHome = function() {
    if (!checkToPath()) return
    router.replace({ path: '/' })
  }

  if (subjectType === 'ACTOR') {
    if (!checkToPath()) {
      return
    }
    /**
     * 展商
     * 登录成功跳转 公司基本信息管理
     */
    // let path = param.path ? param.path : '/company-management'
    let path = param.path ? param.path : '/operationGuide'
    // 如果不是管理员
    if (!info.exhibitorEmployee.admin) {
      path = '/my-exhibit-list'
    } else {
      // path = '/company-management'
      path = '/operationGuide'
    }
    router.replace({ path: path })
  } else if (subjectType === 'VISITOR') {
    /**
     * 观众
     * 登录成功跳转 商机管理
     * 观众注册，没有预登记跳转 首页
     * completeExhibitionRegistration true（预登记） false（没有预登记）
     */
    const status = isCompleteExhibitionRegistration()
    if (status) {
      //获取配置项 共登录成功后的页面应用
      getFetchList()
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            store.commit('SET_CONFIGSWITCH', res.data.configSwitch)
            if (value && value.question == true) {
              router.replace({ path: '/register/completed' })
              return
            }
            // 完成预登记
            if (!checkToPath()) return
            // 禁止观众操作2 (第二次限制)
            if (config.settings.onlayReg2) {
              router.replace({ path: '/profile' })
              return
            }
            router.replace({ path: param.path ? param.path : '/' })
          }
        })
    } else {
      /**
       * 预登记没有完成
       * info.exhibitionUserCompleteState => 登录返回的状态
       * 不管 judgeLanguageByCountry 根据国家判断观众语言 是否开启，都重新获取配置项
       */
      let state = info.exhibitionUserCompleteState

      /**
       * 是否完成 完善信息1
       * info 为空 => status: undefined
       * 或 state 存在 且 state.completeVisitor 为true
       */
      if (!state || (state && !state.completeVisitor)) {
        if (type) {
          // 邮箱 完善信息1
          store.commit('SET_LOGIN_ACCOUNT', value.email || '')
          router.push('/l-register/account-email-info/0')
        } else {
          store.commit('SET_LOGIN_ACCOUNT', value.phone || value.mobile || '')
          // 手机 号完善信息1
          router.push('/l-register/account-mobile-info/0')
        }
        return false
      }

      //获取配置项
      getFetchList()
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            let config = res.data.configSwitch
            store.commit('SET_CONFIGSWITCH', config)

            /**
             * 判断预登记是否后置
             * 否且不是来自预登记|问卷，直接进入二次完善信息（预登记）
             */
            if (config.visitorDelay && (!value || (value && value.secondInfo !== true))) {
              /**
               * 判断是否来自完善信息1
               * 是，有弹框
               * 否，没有弹框，直接进入首页
               */
              if (!value || (value && value.firstInfo !== true)) {
                goHome()
              } else {
                router.replace({ path: '/register/completed' })
                return
                // this.$alert(this.$t('You have registered, you can visit the online exhibition from June 18 to 24 by using this account'), this.$t('Confirm Registration'), {
                //     confirmButtonText: this.$t('ok'),
                //     showClose:false,
                //     callback: () => {
                //         goHome()
                //     }
                // })
              }

              return false
            }

            // 是否完成 完善信息2
            if (!state.completeVisitorRegister) {
              // 跳转 完善信息2
              router.replace({ path: '/register/account-info/1' })
            } else if (!state.completeQuestionnaire) {
              // 跳转 问卷
              router.replace({ path: '/questionnaire' })
            }
          }
        })
    }
  }
}

/**
 * 首次进入 跳转登录页面 登录成功后再次跳转到 之前要进入的页面
 */
const checkToPath = function() {
  var href = window.sessionStorage.getItem('toPath')
  if (href) {
    sessionStorage.removeItem('toPath')
    router.push({ path: href })
    return false
  }
  return true
}

/**
 * 操作限制
 *
 */
const todoPrission = function() {
  const subjectType = store.getters.subjectType
  const info = store.getters.info
  const status = info && info.exhibitionUserCompleteState ? info.exhibitionUserCompleteState.completeExhibitionRegistration : true
  if (subjectType === 'VISITOR') {
    if (!status) {
      // 观众注册 没有预登记
      window.PC.noUnregisteredDiag(() => {
        loginSuccess(subjectType, {}, null, { secondInfo: true })
      })
      return false
    } else if (info.visitor.auditState == 'DISAPPROVE' && info.visitor.languageType == 'cn') {
      // 国内 完成预登 审核不通过
      window.PC.noUnregisteredDiag(
        () => {
          //loginSuccess(subjectType, {}, null, {secondInfo: true})
          console.log('DISAPPROVE')
        },
        null,
        'auditTip1',
        'ok'
      )
      return false
    } else if (info.visitor.auditState == 'PENDING' && info.visitor.languageType == 'cn') {
      // 国内 完成预登 待审核
      window.PC.noUnregisteredDiag(
        () => {
          // 通过接口判断是否审核通过
          getVisitorAuditState()
            .then(res => {
              return res.data
            })
            .then(res => {
              if (!res.data) return
              info.visitor.auditState = res.data
              switch (res.data) {
                case 'APPROVE':
                  // 审核通过
                  store.dispatch('LogOut').then(() => {
                    loginSource({replaceStatus: true})
                  })
                  break
                case 'DISAPPROVE':
                  // 审核不通过
                  store.commit('SET_INFO', info)
                  break
              }
            })
        },
        null,
        'auditTip',
        'ok'
      )
      return false
    }

    return true
  } else {
    return true
  }
}

/**
 * 展商/展品/观众详情/直播详情
 * @param {object} data 详情数据
 * @param {string} type 详情类型
 */
const pageDetail = function(data, type, blank=true) {
  let id = ''
  switch (type) {
    // 观众
    case 'person':
      id = data.visitorId || data.id
      if (actorLimit('VISITOR_DETAIL')) {
        return false
      }
      openNewPage(`/find-person/detail/${id}`, blank)
      break
    // 展品
    case 'product':
      id = data.productId || data.id
      if (data.scope == 1 && data.inPool == false) {
        window.PC.$alter(
          {
            message: i18n.t('common.productTipsContent'),
            title: i18n.t('common.productTipsTitle'),
            confirmButtonText: i18n.t('common.ok')
          },
          () => {
            router.push(`/find-exhibitor/detail/${data.exhibitorId}`)
          }
        )
      } else {
        openNewPage(`/find-exhibit/detail/${id}`, blank)
      }
      break
    case 'self_product':
      id = data.productId || data.id
      openNewPage(`/exhibit-detail/${id}`, blank)
      break
    // 展商
    case 'actor':
      id = data.exhibitorId || data.actorId || data.liveSponsorId || data.url || data.id
      openNewPage(`/find-exhibitor/detail/${id}`, blank)
      break
  }
}

/**
 * 是否完成预登记
 */
const isCompleteExhibitionRegistration = function(status = false) {
  const info = store.getters.info
  const rStatus = info && info.exhibitionUserCompleteState ? info.exhibitionUserCompleteState.completeExhibitionRegistration : status
  return rStatus
}

/**
 * 判断是否登录, 未登录出现弹框提示
 */
const isLoginFn = function(fn) {
  if (!isLoginStatus()) {
    let s = i18n.t('finds.loginTip')
    let sT = i18n.t('finds.tip')
    window.PC.$alter(
      {
        message: s,
        title: sT,
        confirmButtonText: i18n.t('common.ok')
      },
      () => {
        if (fn) {
          fn()
        } else {
          loginSource()
        }
      }
    )
    return false
  } else {
    return true
  }
}

/**
 * 判断登录状态
 */
const isLoginStatus = function() {
  return getToken() && store.getters.subjectType 
  && store.getters.isLogin == 1 
  && store.getters.info && store.getters.info.id
}

/**
 * 直播状态
 */
const liveStatusText = function(liveObj) {
  let status = liveObj.liveState
  let text = ''
  if (status == 1) {
    text = i18n.t('live.status["1"]')
  } else if (status == 2) {
    text = i18n.t('live.status["0"]')
  } else {
    text = i18n.t('live.status["2"]')
  }
  return text
}

const openNewPage = function(path, blank=false) {
  const { href } = router.resolve({
    path: path
  })
  if (blank) {
    window.open(href, '_blank')
  } else {
    router.push(path)
  }
}

/**
 * 关闭浏览器当前窗口
 */
const closeBrowserPage = function() {
  window.opener = null
  window.open('', '_self')
  window.close()
}

/**
 * 判断是否是展商
 * 展商 不可操作的行为判断
 * status Boolean 是否判断当前身份 是否展商
 */
const ActorNoTodo = function(status) {
  if (config.settings.noActor) {
    if ((status === true && store.getters.subjectType === 'ACTOR') || !status) {
      store.commit('setNoActorTodo', true)
      return false
    }
  }

  return true
}

const noVisitorTodoAction = () => {
  if (!config.settings.onlayReg) return
  store.commit('setNoVisitorTodo', true)
}

/**
 * 网站埋点 =》注册流程
 * 其他操作的埋点
 * 只有当前身份是非展商时才会埋点
 * @param {Object} behavior 用户行为ID 或者 为用户行为描述对象
 * @param {String | Object} action 行为描述code | 参数
 */
const $tracking = (behavior, action = '001021003') => {
  if (store.getters.subjectType === 'ACTOR') return
  let userId = store.getters.info ? store.getters.info.visitor : ''
  userId = userId ? userId.id : ''
  let params = {
    appKey: 'A00010', // I展通
    type: '000000001', // 观众
    userId: userId || store.getters.loginAccount || '', //用户账号（用户id|邮箱|手机号）
    time: new Date().getTime(),
    site: config.exhibitionId, // 展会ID
    event: '', // 用户行为记录
    prop: {
      terminal: 'PC',   //终端
    }
  }

  if (getType(action) == 'string') {
    params.event = action
  } else if (getType(action) == 'object') {
    params = Object.assign(params, action)
  }

  if (getType(behavior) == 'string' && behavior) {
    params['prop']['behavior'] = behavior
  } else if (behavior) {
    params['prop'] = {
      ...params['prop'],
      ...behavior
    }
  }
  webTracking(params)
}

// 用于主办后台广告位分享统计 (浏览量)
const hostAdvertisingSharingStatistics = function() {
  let pathName = window.location.pathname
  let origin = window.location.origin
  let logsPath = ['/login', '/'] //埋点的地址
  if (pathName === '/login/person') pathName = '/login'
  if (!logsPath.includes(pathName)) return
  let fromUrl = store.getters.fromUrl
  let advertisingSharing = store.getters.advertisingSharing
  let t1 = getType(fromUrl) === 'string' && !!fromUrl
  let t2 = getType(advertisingSharing) === 'string' && !!advertisingSharing
  let t3 = advertisingSharing === (origin + pathName)
  if (pathName === '/login' && store.getters.subjectType !== 'VISITOR') return
  if (t1 && t2 && t3) {
    $tracking({
      source: fromUrl,
      device: navigator.userAgent,
      current: origin + pathName
    }, '001021004')
  }
}

// 用于主办后台广告位分享统计 (预登记完成-注册完成)
const completeVisitorRegisterSharingStatistics = function() {
  let fromUrl = store.getters.fromUrl
  let advertisingSharing = store.getters.advertisingSharing
  let t1 = getType(fromUrl) === 'string' && !!fromUrl
  let t2 = getType(advertisingSharing) === 'string' && !!advertisingSharing
  if (t1 && t2) {
    $tracking({
      source: advertisingSharing + '?fromUrl=' + fromUrl,
      device: navigator.userAgent,
      current: window.location.origin + window.location.pathname
    }, '001021004')
  }
}

// 通过展商邀请函进入 网站统计(浏览量)
const invitationStatistics = function() {
  commonStatistics('001031000', store.getters.invitationSource)
}

/**
 * 埋点
 */
const commonStatistics = function(action, params) {
  if (store.getters.subjectType === 'ACTOR') return
  let info = store.getters.info
  let pop = {}
  let userId = info ? (info.visitor ? info.visitor.email : '') : ''
  switch(action) {
    // 通过展商邀请函进入 网站统计(浏览量)
    case '001031000':
      userId = params.email
      pop = {
        "source": params.exhibitorId,
        "device": "yaoqinghan",
        "current": "yaoqinghan"
      }
      break
    // 观众首页腰部轮播埋点统计
    case '001032000':
      pop = {
        "source": params['coverIcon'],
        "device": "index",
        "current": "indexyaobulunbotu"
      }
      break
    // 观众首页视频播放埋点统计
    case '001033000':
      pop = {
        "source": params['url'],
        "device": "index",
        "current": "indexvideo"
      }
      break
    // 观众首页banner轮播图统计
    case '001034000':
      pop = {
        "source": params['coverIcon'],
        "device": "index",
        "current": "indexshangbulunbotu"
      }
      break
    // 导航菜单 首页
    case '001035001':
      pop = {
        "source": "indexbutton",
        "device": "index",
        "current": "button "
      }
      break
    // 导航菜单 找展商
    case '001035002':
        pop = {
          "source": "indexsearchexhibitor",
          "device": "index",
          "current": "button "
        }
        break
    // 导航菜单 找展品   
    case '001035003':
      pop = {
        "source": "indexsearchproduct",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 3D展馆图
    case '001035004':
      pop = {
        "source": "index3dmap",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 商脉圈
    case '001035005':
      pop = {
        "source": "indexopportunity",
        "device": "index",
        "current": "button"
      }
      break
    // 导航菜单 直播
    case '001035006':
      pop = {
        "source": "indexlive",
        "device": "index",
        "current": "button"
      }
      break
  }
  pop.terminal = 'PC'
  $tracking(pop, {
    'event': action,
    'userId': userId
  })
}

/**展商权限限制
 * source 来源 Object | String
 *        Object => 根据路由name判断
 *        String => 根据类型判断
 * isAlert 
 */
const actorLimit = function (source, isAlert=true) {
    /**
     * 邀约 INVITATION
      沟通记录 CONTACT_LOG (客户端APP)
      员工管理 EMPLOYEE_MANAGER (添加员工)
      直播 LIVE (新建直播)
      意向订单 INTENTION_ORDER (意向订单管理)
      上传展品 UPLOAD_PRODUCT
      数据报告 DATA_REPORT
      热点图片上传 HOT_IMG_UPLOAD (添加热点图)
      展商资料上传 EXHIBITOR_DATUM_UPLOAD
      展商海报分享 EXHIBITOR_POSTER (客户端APP)
      二维码打证入场 QRCODE_ADMIT (客户端APP)
      电话 PHONE (客户端APP)
      在线消息 IM
      商机推荐 CUSTOMEINVITATION (客户端APP)
      广告 ADV
      搜索客户 SEARCH_VISITOR (观众列表搜索框)
      发商脉圈 PUBLISH_COMMERCIAL
      被他人邀约 INVITEE (暂时不做)
      加客户池 ADD_CONTACT_PERSON (客户端APP)
      观众详情 VISITOR_DETAIL
      商脉圈列表 LIST_COMMERCIAL (顶部导航商脉圈列表)
      邀请函 INVITATION_LETTER
      展商手册 EXHIBITOR_MANUAL (客户端APP)
      报名活动 SIGN_UP_ACTIVITY (客户端APP)
    */
    if (!source) {
      console.error('没有来源')
      return false
    }
    let alertFn = function() {
        if (!isAlert) return
        window.PC.$alter({
            title: i18n.t('tips'),
            message: i18n.t('withoutPermission')}
        )
    }
    let limits = store.getters.checkBannedList
    let status = false
    if (typeof source === 'string') {
      switch (source) {
        // 详情
        case 'VISITOR_DETAIL':
            if (limits.VISITOR_DETAIL) {
                status = true
            }
            break
        // 邀约
        case 'INVITATION':
            if (limits.INVITATION) {
                status = true
            }
            break
        // IM
        case 'IM':
            if (limits.IM) {
                status = true
            }
            break
        // 邀请函
        case 'INVITATION_LETTER':
            if (limits.INVITATION_LETTER) {
                status = true
            }
            break
        // 观众搜索
        case 'SEARCH_VISITOR':
            if (limits.SEARCH_VISITOR) {
                status = true
            }
            break
      }
      if (status === true) {
        alertFn()
      }
      return status
    }
    const name = source.name
    if (limits.EMPLOYEE_MANAGER && ['AddEmployee'].includes(name)) {
      // 员工管理
      alertFn()
      return true
    } else if (limits.INTENTION_ORDER && ['potentialOrder'].includes(name)) {
      // 意向订单
      alertFn()
      return true
    } else if (limits.UPLOAD_PRODUCT && ['AddExhibit'].includes(name)) {
      // 上传展品
      alertFn()
      return true
    } else if (limits.DATA_REPORT && ['report'].includes(name)) {
      // 数据报告
      alertFn()
      return true
    } else if (limits.HOT_IMG_UPLOAD && ['hotspot-detail'].includes(name) && !source.params.id) {
      // 热点图片上传
      alertFn()
      return true
    } else if (limits.EXHIBITOR_DATUM_UPLOAD && ['ExhInformation'].includes(name)) {
      // 展商资料上传
      alertFn()
      return true
    } else if (limits.PUBLISH_COMMERCIAL && ['opportunityManage'].includes(name) && source.params.action === 'publish') {
      // 发商脉圈
      alertFn()
      return true
    } else if (limits.VISITOR_DETAIL && ['findPersonDetail'].includes(name)) {
      // 观众详情
      alertFn()
      return true
    } else if (limits.LIST_COMMERCIAL && ['findOpportunity'].includes(name)) {
      // 商脉圈列表
      alertFn()
      return true
    }
    return false
}

export default {
  loginSuccess,
  checkToPath,
  todoPrission,
  liveStatusText,
  pageDetail,
  openNewPage,
  closeBrowserPage,
  isCompleteExhibitionRegistration,
  isLoginFn,
  isLoginStatus,
  ActorNoTodo,
  noVisitorTodoAction,
  $tracking,
  hostAdvertisingSharingStatistics,
  completeVisitorRegisterSharingStatistics,
  invitationStatistics,
  commonStatistics,
  loginSource,
  actorLimit
}
